/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from 'react';
import ReactDOM from 'react-dom/client';
import { StyledEngineProvider } from '@mui/material/styles';
import './css/index.css';
import App from './App';
import { CookiesProvider } from 'react-cookie';

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

root.render(
  <CookiesProvider>
    <StyledEngineProvider injectFirst>
      <App />
    </StyledEngineProvider>
  </CookiesProvider>
);
